import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { UserLayout } from '@/components/layout/UserLayout';
import { AdminProtectedRoute, AdminPublicRoute } from '@/components/routing/AdminRouteGuards';
import { UserProtectedRoute, UserPublicRoute } from '@/components/routing/UserRouteGuards';
import { ROUTES } from '@/constants/routes';
import { AdminLoginPage } from '@/pages/auth/AdminLoginPage';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { LandingPage } from '@/pages/landing/LandingPage';
import {
  AdminDashboardHome,
  AdminPlaceholderPage,
  AdminProfilePage,
} from '@/pages/admin/AdminPages';
import { AdminUsersPage } from '@/pages/admin/AdminUsersPage';
import { AdminUserDetailPage } from '@/pages/admin/AdminUserDetailPage';
import { AdminVirtualAccountsPage } from '@/pages/admin/AdminVirtualAccountsPage';
import { AdminAirtimePricingPage } from '@/pages/admin/AdminAirtimePricingPage';
import { AdminDataPlansPage } from '@/pages/admin/AdminDataPlansPage';
import { AdminBillPricingPage } from '@/pages/admin/AdminBillPricingPage';
import { AdminVerificationPricingPage } from '@/pages/admin/AdminVerificationPricingPage';
import { AdminTransactionDetailPage } from '@/pages/admin/AdminTransactionDetailPage';
import { AdminTransactionsPage } from '@/pages/admin/AdminTransactionsPage';
import { NinVerificationPage } from '@/pages/user/NinVerificationPage';
import { NinSlipVerifyPage } from '@/pages/user/NinSlipVerifyPage';
import { BvnVerificationPage } from '@/pages/user/BvnVerificationPage';
import { AirtimePage } from '@/pages/user/AirtimePage';
import { DataPage } from '@/pages/user/DataPage';
import { ElectricityPage } from '@/pages/user/ElectricityPage';
import { CableTvPage } from '@/pages/user/CableTvPage';
import { ExamsPage } from '@/pages/user/ExamsPage';
import {
  UserDashboardHome,
  UserServicesPage,
} from '@/pages/user/UserPages';
import { ContactSupportPage } from '@/pages/user/ContactSupportPage';
import { UserTransactionsPage } from '@/pages/user/UserTransactionsPage';
import { UserMorePage } from '@/pages/user/UserMorePage';
import { UserProfilePage } from '@/pages/user/UserProfilePage';
import { UserSecurityPage } from '@/pages/user/UserSecurityPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.home} element={<LandingPage />} />

      <Route element={<UserPublicRoute />}>
        <Route path={ROUTES.login} element={<LoginPage />} />
        <Route path={ROUTES.register} element={<RegisterPage />} />
        <Route path={ROUTES.forgotPassword} element={<ForgotPasswordPage />} />
      </Route>

      <Route element={<AdminPublicRoute />}>
        <Route path={ROUTES.adminLogin} element={<AdminLoginPage />} />
      </Route>

      <Route element={<UserProtectedRoute />}>
        <Route element={<UserLayout />}>
          <Route path={ROUTES.dashboard} element={<UserDashboardHome />} />
          <Route path={ROUTES.dashboardAirtime} element={<AirtimePage />} />
          <Route path={ROUTES.dashboardData} element={<DataPage />} />
          <Route path={ROUTES.dashboardElectricity} element={<ElectricityPage />} />
          <Route path={ROUTES.dashboardCableTv} element={<CableTvPage />} />
          <Route path={ROUTES.dashboardExams} element={<ExamsPage />} />
          <Route path={ROUTES.dashboardServices} element={<UserServicesPage />} />
          <Route path={ROUTES.dashboardVerifyNin} element={<NinVerificationPage />} />
          <Route path={ROUTES.dashboardVerifyNinSlip} element={<NinSlipVerifyPage />} />
          <Route path={ROUTES.dashboardVerifyBvn} element={<BvnVerificationPage />} />
          <Route path={ROUTES.dashboardTransactions} element={<UserTransactionsPage />} />
          <Route path={ROUTES.dashboardProfile} element={<UserProfilePage />} />
          <Route path={ROUTES.dashboardSecurity} element={<UserSecurityPage />} />
          <Route path={ROUTES.dashboardContactSupport} element={<ContactSupportPage />} />
          <Route path={ROUTES.dashboardMore} element={<UserMorePage />} />
        </Route>
      </Route>

      <Route element={<AdminProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route path={ROUTES.adminRoot} element={<AdminDashboardHome />} />
          <Route path={ROUTES.adminProfile} element={<AdminProfilePage />} />
          <Route path={ROUTES.adminUsers} element={<AdminUsersPage />} />
          <Route path={ROUTES.adminUserDetail} element={<AdminUserDetailPage />} />
          <Route path={ROUTES.adminVirtualAccounts} element={<AdminVirtualAccountsPage />} />
          <Route path={ROUTES.adminAirtimePricing} element={<AdminAirtimePricingPage />} />
          <Route path={ROUTES.adminDataPlans} element={<AdminDataPlansPage />} />
          <Route path={ROUTES.adminBillPricing} element={<AdminBillPricingPage />} />
          <Route path={ROUTES.adminVerificationPricing} element={<AdminVerificationPricingPage />} />
          <Route path={ROUTES.adminTransactions} element={<AdminTransactionsPage />} />
          <Route path={ROUTES.adminTransactionDetail} element={<AdminTransactionDetailPage />} />
          <Route path={ROUTES.adminSettings} element={<AdminPlaceholderPage title="Settings" />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
}
